export function getPaymentsForPayoutV3(send) {
  return (payoutId, query, ...args) =>
    send(
      {
        path: '/v3/payouts/{payoutId}/payments',
        pathParameters: { payoutId },
        type: 'get',
        query: query,
        body: undefined,
        headers: undefined,
        auth: 'oauth2',
        contentType: undefined,
      },
      ...args
    );
}
